// extracted by mini-css-extract-plugin
export default {"lotSizeInputLabel":"styles_lotSizeInputLabel__8P5kX","altLabel":"styles_altLabel__L8vuy","horizontalOptions":"styles_horizontalOptions__mHsFU","separator":"styles_separator__Cz+o6"};